<template>
  <div class="suscription">
    <div
      class="text-subtitle-1 font-weight-semibold mb-2"
      v-if="!isProvider"
    >
      ¡Afíliate ahora!
    </div>
    <div
      class="mb-8"
      v-if="!isProvider">
      Llena este
      <a
        @click="goToAffiliation"
      >formulario</a>
      o déjanos tu correo y nos pondremos en contacto.
    </div>
    <v-sheet
      class="d-flex transparent rounded overflow-hidden mb-4"
    >
      <v-text-field
        v-model="email"
        solo
        flat
        class="rounded-0"
        color="white"
        hide-details
        @keyup.enter="sendSuscription"
        label="correo electrónico"
        :disabled="isSendingMail"
        required
      />
      <v-btn
        color="#0498af"
        tile
        depressed
        class="white--text"
        x-large
        height="48px"
        @click="sendSuscription"
        :loading="isSendingMail"
      >
        Enviar
      </v-btn>
    </v-sheet>
  </div>
</template>

<script>

import mailingController from '@/controllers/Mailing';

export default {
  name: 'Suscription',
  data() {
    return {
      email: '',
      isSendingMail: false,
    };
  },
  computed: {
    thisYear() {
      const d = new Date();
      const year = d.getFullYear();
      return year;
    },
    isProvider() {
      return this.$auth.check() && this.$auth.user().provider;
    },
  },
  methods: {
    sendSuscription() {
      if (this.email) {
        this.isSendingMail = true;
        mailingController.sendSuscription(
          this.email,
          'footer.suscription',
          '',
        ).then(() => {
          this.email = '';
          this.$success('Genial. Tu suscripción ha sido registrada.');
          this.isSendingMail = false;
        }).catch(() => {
          this.$error('No se pudo registrar tu suscripción. Por favor, intenta nuevamente.');
          this.isSendingMail = false;
        });
      } else {
        this.$error('Ingresa tu correo electrónico');
      }
    },
    goToAffiliation() {
      if (this.$auth.check()) {
        const user = this.$auth.user();
        if (user.provider) {
          this.$router.push({
            name: 'providersite',
            params: {
              slug: user.provider.slug,
            },
          });
        } else {
          this.$router.push({
            name: 'affiliation',
          });
        }
      } else {
        this.$router.push({
          name: 'affiliation',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.suscription {
  max-width: 380px;

  a {
    color:#fff!important;
    text-decoration: underline!important;
  }
}
</style>
